import { Component, Host, h } from '@stencil/core';

declare let window: any;

@Component({
  tag: 'lilu-chat',
  styleUrl: 'lilu-chat.scss',
})
export class LiluChat {
  // userlike Documentation
  // https://docs.userlike.com/de/setup/integration/html

  readonly scriptUrl = 'https://userlike-cdn-widgets.s3-eu-west-1.amazonaws.com/b80cfdcac84d4368ad28ec1b4dffdd008148fde9b16b4d1185fae1f1dd09ad80.js';

  buildChatScript(): HTMLScriptElement {
    const chatScript = document.createElement('script');
    chatScript.type = 'text/javascript';
    chatScript.async = true;
    chatScript.src = this.scriptUrl;

    chatScript.onerror = e => {
      console.error('LiluChat error', e);
    };

    return chatScript;
  }

  componentDidLoad() {
    document.body.appendChild(this.buildChatScript());
  }

  render() {
    return <Host></Host>;
  }
}
